<template>
  <section class="animation-box-catalog">
    <div
      v-if="catalogInfo && isVisible"
      :id="`animation_box_index_${multisectionIndex}`"
      ref="onDisplay"
      class="multi animation-box-band"
    >
      <lazy-component @show="setData">
        <CellList :cell-list="cellList" :thumbnail-info="thumbnailInfo" />
      </lazy-component>
    </div>
  </section>
</template>

<script setup>
  import { ref } from 'vue'
  import { convertBand } from '@/common/converter/convert-band'
  import { useEventOnDisplay } from '@/common/use/useEventOnDisplay'
  import CellList from '@/components/band/CellList.vue'

  const props = defineProps({
    catalogInfo: {
      type: Object,
      default: () => {},
    },
    sectionInfo: {
      type: Object,
      default: null,
    },
    thumbnailInfo: {
      type: Object,
      default: () => {},
    },
    multisectionIndex: {
      type: Number,
      default: 0,
    },
  })

  const onDisplay = ref(null)
  useEventOnDisplay(onDisplay, props.sectionInfo)
  const cellList = ref([])
  const catalog = ref({})
  const isVisible = ref(true)

  const setData = async () => {
    try {
      catalog.value = await convertBand(props.catalogInfo)
      cellList.value = catalog.value?.band?.celllist ?? []
      isVisible.value = cellList.value.length > 0
    } catch (e) {
      console.error(e.message)
      isVisible.value = false
    }
  }
</script>

<style lang="scss" scoped>
  .multi {
    width: auto;
    .swiper-button-prev,
    .swiper-button-next {
      left: 70px;
      opacity: 0;
    }
    .swiper-button-next {
      left: auto;
      right: 70px;
    }
    &.animation-box-band {
      min-height: 174px;
    }
  }
</style>
